export function EsecondGallery() {
    return (
        <section className="secondGallery-main-box">
            <h1>ANFRO</h1>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <h3>the smartest choice</h3>
        </section>
    )
}